/* eslint-disable */

import { variablesTranslete } from '@/enums/tamplates'
import { updateTemplateById } from '@/requests/templates'
import { showDefaultErrorMessage } from '@/utils/createMessage'
import { Message } from 'element-ui'
import Api from '@/repository/index'

const state = {
  types: [],
  tamplates: [],
  variables: [],
  loading_types: true,
  car_region_park: null,
  waybill_file: null,
  loading_tamplates: true,
  offer_tamplates: []
}

const mutations = {
  SET_TAMPLATES: (state, data) => {
    state.tamplates = data
  },
  SET_WAYBILL: (state, data) => {
    state.waybill_file = data
  },
  ADD_TAMPLATE: (state, data) => {
    state.tamplates.push(data)
  },
  ADD_OFFER_TAMPLATE: (state, data) => {
    state.offer_tamplates.push(data)
  },
  SET_OFFER_TAMPLATES: (state, data) => {
    state.offer_tamplates = data
  },
  UPDATE_TAMPLATE: (state, data) => {
    state.tamplates = [...state.tamplates.filter(x => x.id !== data.id), { ...state.tamplates.filter(x => x.id === data.id), ...data }]
  },
  DELETE_TAMPLATE: (state, id) => {
    state.tamplates = [...state.tamplates.filter(x => x.id !== id)]
  },
  SET_REGION_PARK: (state, data) => {
    state.car_region_park = data
  },
  SET_VARIABLES: (state, data) => {
    state.variables = data
  },
  SET_TYPES: (state, data) => {
    state.types = data
  },
  ADD_TYPE: (state, data) => {
    state.types.push(data)
  },
  UPDATE_TYPE: (state, data) => {
    state.types = [...state.types.filter(x => x.id !== data.id), { ...data }]
  },
  DELETE_TYPE: (state, id) => {
    state.types = [...state.types.filter(x => x.id !== id)]
  },
  UPDATE_LOADING_TYPES: (state, boolean) => {
    state.loading_types = boolean
  },
  UPDATE_LOADING_TAMPLATES: (state, boolean) => {
    state.loading_tamplates = boolean
  }

}

const actions = {
  async checkUniqueDocument ({
    commit,
    state
  }, {
    contract_type,
    car_region_park,
    investor_type
  }) {
    try {
      const result = state.tamplates.findIndex(x => x.contractType === contract_type && x.carRegionPark === car_region_park && x.investorType === investor_type)
      console.log(result)
      if (result === -1) return true
      return false
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async checkUniqueDocumentType ({
    commit,
    state
  }, name) {
    try {
      const result = state.types.findIndex(x => x.name === name)
      if (result === -1) return true
      return false
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async createTemplate ({ commit }, FormData) {
    try {
      const data = await Api.contracts.templates.createContractTemplate(FormData)

      Message({
        type: 'success',
        message: 'Шаблон успешно создан!'
      })
      commit('ADD_TAMPLATE', data)
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async createParkTemplate ({
    dispatch,
    commit
  }, FormData) {
    try {
      const data = await Api.contracts.park.createParkContractTamplate(FormData)

      Message({
        type: 'success',
        message: 'Шаблон Оферты успешно создан!'
      })
      // commit('ADD_OFFER_TAMPLATE', data)
      dispatch('getParkTemplates')
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateParkTemplate ({
    dispatch,
    commit
  }, FormData) {
    try {
      const data = await Api.contracts.park.updateParkContractTamplate(FormData)

      Message({
        type: 'success',
        message: 'Шаблон Оферты успешно обновлен!'
      })
      // commit('ADD_OFFER_TAMPLATE', data)
      dispatch('getParkTemplates')
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  // @deprecated - @/modules/edmTemplates/store/EdmOffer.store.ts
  async getParkTemplates ({
    commit,
    state
  }) {
    try {
      commit('UPDATE_LOADING_TAMPLATES', true)
      const data = await Api.contracts.park.getParkContractTemplates()
      commit('SET_OFFER_TAMPLATES', data)
      commit('UPDATE_LOADING_TAMPLATES', false)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit('UPDATE_LOADING_TAMPLATES', false)
    }
  },
  async getWaybillTemplate ({
    commit,
    state
  }) {
    try {
      const data = await Api.contracts.waybill.getWaybillTemplate()
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateCreateWaybillTemplate ({
    commit,
    state
  }, dataArgs) {
    try {
      await Api.contracts.waybill.updateCreateWaybillTemplate(dataArgs)
      Message({
        type: 'success',
        message: 'Шаблон успешно обновлен / создан!'
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  // @deprecated - @/modules/edmTemplates/store/EdmOffer.store.ts
  async deleteParkTemplates ({
    commit,
    dispatch
  }, id) {
    try {
      commit('UPDATE_LOADING_TAMPLATES', true)
      await Api.contracts.park.deleteParkContractTamplate(id)
      await dispatch('getParkTemplates')
      commit('UPDATE_LOADING_TAMPLATES', false)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit('UPDATE_LOADING_TAMPLATES', false)
    }
  },

  // @deprecated - @/modules/edmTemplates/store/ContractTypes.store.ts
  async getTemplateTypes ({ commit }) {
    try {
      commit('UPDATE_LOADING_TYPES', true)
      const data = await Api.contracts.types.getContractTypes()
      commit('SET_TYPES', data)
      commit('UPDATE_LOADING_TYPES', false)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit('UPDATE_LOADING_TYPES', false)
    }
  },

  async getTemplates ({
    commit,
    state
  }) {
    try {
      commit('UPDATE_LOADING_TAMPLATES', true)
      const carRegionParkId = state.car_region_park
      if (!carRegionParkId || carRegionParkId === 'any') return
      const data = await Api.contracts.templates.getContractTemplates({ carRegionParkId })
      commit('SET_TAMPLATES', data)
      commit('UPDATE_LOADING_TAMPLATES', false)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit('UPDATE_LOADING_TAMPLATES', false)
    }
  },
  async getTemplateVariables ({ commit }) {
    try {
      const data = await Api.contracts.templates.getContractTemplateVariables()
      commit('SET_VARIABLES', data)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async setCarRegionPark ({ commit }, park_id) {
    try {
      await commit('SET_REGION_PARK', park_id)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  // @deprecated - @/modules/edmTemplates/store/ContractTypes.store.ts
  async createTemplateType ({ commit }, params) {
    try {
      const data = await Api.contracts.types.createContractType(params)
      commit('ADD_TYPE', data)
      Message({
        type: 'success',
        message: 'Тип успешно создан!'
      })
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  // @deprecated - @/modules/edmTemplates/store/ContractTypes.store.ts
  async updateTemplateTypeById ({ commit }, body) {
    try {
      const {
        isBindCar,
        isAutoUpdate,
        isBindInvestor,
        isFine,
        expiredSeconds,
        isTxt,
        name,
        signWithApp
      } = body
      const data = await Api.contracts.types.updateContractType(body.id, {
        isBindCar,
        isAutoUpdate,
        isBindInvestor,
        isFine,
        expiredSeconds,
        isTxt,
        name,
        signWithApp
      })
      commit('UPDATE_TYPE', data)
      Message({
        type: 'success',
        message: 'Тип успешно обновлен!'
      })
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async deleteTemplateTypeById ({ commit }, id) {
    try {
      const data = await Api.contracts.types.deleteContractType(id)
      commit('DELETE_TYPE', id)
      Message({
        type: 'success',
        message: 'Тип успешно удален!'
      })
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async deleteTemplateById ({ commit }, id) {
    try {
      const data = await Api.contracts.templates.deleteContractTemplate(id)
      commit('DELETE_TAMPLATE', id)
      Message({
        type: 'success',
        message: 'Успешно удален!'
      })
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getTemplateById ({ commit }, id) {
    try {
      const data = await Api.contracts.templates.getContractTemplateById(id)
      return data
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateTemplateById ({ commit }, {
    id,
    data,
    upd
  }) {
    try {
      console.log(data)
      const res = await updateTemplateById(id, data)
      commit('UPDATE_TAMPLATE', upd)
      Message({
        type: 'success',
        message: 'Шаблон успешно обновлен!'
      })
      return res
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  }
}
const getters = {
  getTamplateById: (state) => (id) =>
    state.tamplates.find((cur) => cur.id === id),
  // @deprecated - @/modules/edmTemplates/store/ContractTypes.store.ts
  getTypeById: (state) => (id) => state.types.find((cur) => cur.id === id),
  getVariablesCascaderVariant: (state) => {
    return state.variables.map((x, index) => {
      return {
        value: x?.name,
        label: variablesTranslete[x?.name],
        children: Object.keys(x.variables).map((y, idx) => {
          return {
            value: y,
            label: x.variables[y],
          }
        }),
      }
    })
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
